import { FC } from 'react';

import cn from 'classnames';
import { convertToAmount } from 'utils/helpers';

type PROPS = {
  items: {
    amount: number;
    closedAt: Date;
    stageId: string;
    name: string;
    _id: string;
  }[];
};

const ColumnTotals: FC<PROPS> = ({ items }) => {
  const totalAmount = items?.reduce((a, b) => a + b.amount, 0);

  return (
    <div
      className={cn(
        'inline-flex items-end justify-end',
        'h-16 w-[270px] pr-4',
        'backdrop-blur-sm',
      )}
    >
      <p className="text-lg font-semibold">
        Total ${convertToAmount(totalAmount ?? 0)}
      </p>
    </div>
  );
};

export default ColumnTotals;
